import type { AxiosError } from 'axios'

/**
 * Текст ошибки записи продукта в корзину. Коды описаны в контракте, наружу их
 * выносить незачем. Общий для обеих вкладок: цену теперь вводят и из рецепта.
 */
export const writeErrorText = (error: AxiosError | null): string | null => {
  if (!error) return null
  const status = error.response?.status
  if (status === 400)
    return 'Такого продукта больше нет в справочнике — обновите список'
  if (status === 403)
    return 'Раздел доступен по подписке — похоже, она закончилась'
  if (status === 404)
    return 'Этот продукт уже убрали из корзины — добавьте его заново'
  if (status === 422)
    return 'Проверьте объём и цену: объём больше нуля, цена не меньше нуля'
  return 'Не удалось сохранить. Попробуйте ещё раз'
}

export const removeErrorText = (error: AxiosError | null): string | null => {
  if (!error) return null
  if (error.response?.status === 403)
    return 'Раздел доступен по подписке — похоже, она закончилась'
  return 'Не удалось убрать продукт. Попробуйте ещё раз'
}
